import React, { useEffect, useState } from 'react';
import { getDropdowns } from './constants';
import ChargeModification from './ChargeModification';
import ALoader from '../../../common/a-loader';
import { ReactComponent as BackArrow } from "../../../../../../assets/img/svg/BackArrow.svg";
import { useHistory } from "react-router-dom";


const ChargeModiBUPanIndiaConfig = () => {

    const [dropdownData, setDropdownData] = useState({ loading: false, data: {} });

    const history = useHistory();

    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                setDropdownData(prev => ({ ...prev, loading: true }));
                const data = await getDropdowns();
                setDropdownData(prev => ({ ...prev, data }));
            } catch (err) {
                console.error(err);
            } finally {
                setDropdownData(prev => ({ ...prev, loading: false }))
            }
        }
        fetchDropdownData();
    }, []);
    return (

        <div className='d-flex flex-column'>
            {dropdownData?.loading && <ALoader position={"fixed"} />}

            <div className='mb-3'>
                <BackArrow className="color-black mr-2 cursor" onClick={() => history.goBack()} />
                <h3 className="color-black d-inline">{'Charge Modification Configuration'}</h3>
            </div>

            <ChargeModification forPANIndia={true} dropdownData={dropdownData?.data} />
            <ChargeModification dropdownData={dropdownData?.data} />

        </div>


    );
}

export default ChargeModiBUPanIndiaConfig;